import { render, staticRenderFns } from "./FormReceivableAccount.vue?vue&type=template&id=4d08aa30&"
import script from "./FormReceivableAccount.vue?vue&type=script&lang=js&"
export * from "./FormReceivableAccount.vue?vue&type=script&lang=js&"
import style0 from "./FormReceivableAccount.vue?vue&type=style&index=0&id=4d08aa30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports